module.exports = __webpack_public_path__ + "static/media/redhill-logo.5c7fbead.png";